import { Col, Container, Row } from "reactstrap";
import ProfileLayout from "../../../layouts/ProfileLayout";
import PropertyCard from "../../../components/Cards/PropertyCard";
import { useEffect, useState } from "react";
import { API_URL } from "../../../utils/constants";
import { ReactComponent as EmptyIcon } from '../../../assets/images/icons/empty.svg';
import { useTranslation } from "react-i18next";

function FavoritesPage() {
  const { t } = useTranslation('favorites');
  const [favoritesLoading, setFavoritesLoading] = useState(true);
  const [favorites, setFavorites] = useState([]);

  const getFavorites = () => {
    setFavoritesLoading(true);

    fetch(API_URL+'/user/favorites', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setFavorites(data.favorites.data);
      }
      setFavoritesLoading(false);
    })
  }

  useEffect(() => {
    getFavorites();
  }, []);  

  return(
    <ProfileLayout>
      <Row className="justify-content-center">
        <Col lg="8">
          <h4>{t('title')}</h4>
        </Col>
      </Row>

      {favoritesLoading ?
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      :
        <Row className="justify-content-center">
          {favorites?.length > 0 ?
            favorites.map((data, key) => {
              return(
                <Col lg="8" key={key}>
                  <PropertyCard property={data.property} />
                </Col>
              );
            })
          :
            <Col lg="8" className="text-center py-5">
              <EmptyIcon />

              <h6 className="mt-4 fw-normal text-muted">{t('empty')}</h6>
            </Col>
          }
        </Row>
      }
    </ProfileLayout>
  );
}

export default FavoritesPage;